import React from 'react';
import { observer } from 'mobx-react';

// Config
import { config } from '../config';

// Dependencies
import { LaunchDarkly, FeatureFlag } from 'react-launch-darkly';
import jwt_decode from 'jwt-decode';
import LogRocket from 'logrocket';

// Components
import Loader from './Common/Loader';
import Dialog from './Common/Dialog';
import Confirm from './Common/Confirm';
import Toaster from './Common/Toaster';
import Notification from './Common/Notification';
import Prompt from './Common/Prompt';

// Store
import store from '../stores/';

// Helpers
import { getParam } from '../helpers/helpers';

class AppOutside extends React.Component {
  componentWillMount() {
    const { SessionStore } = store;

    // Get translations
    if(!SessionStore.translationLoaded) {
      SessionStore.getTranslation(SessionStore.locale);
    }
  }

  componentDidMount() {
    const { SessionStore } = store;

    let token = getParam('token', window.location.href)
    if(token && token !== '') {
      SessionStore.setUserData(jwt_decode(token));
    }

    if(process.env.REACT_APP_ENVIRONMENT === 'production') {
      if(!store.SessionStore.logRocketInit) {
        LogRocket.init(config.logRocket);
        store.SessionStore.logRocketInit = true;
      }
    }

    this.renderAgreements();
    this.renderZDChat();
  }

  checkToken() {
    const { SessionStore } = store;
    SessionStore.checkToken();
  }

  handleChromeStoreId(value) {
    const { SessionStore } = store;

    config.extensionUrl = `https://chrome.google.com/webstore/detail/smarterproctoring/${value}`;
    config.extensionId = value;
    config.extensionManifestUrl = `https://smarterproctoring-extension.s3.amazonaws.com/manifest.${value}.json`

    // Get extension info from the manifest
    SessionStore.getExtensionInfo();

    // Since this is called by the LaunchDarkly FeatureFlag
    // component which is inside the render function, we
    // need to return either null, a string, or an element
    // or else React will freak out.
    return null;
  }

  renderAgreements() {
    const _this = this;
    const agrScript = document.querySelector('#agr-ui');

    if(!agrScript) {
      let agr = document.createElement('script');
      agr.id = 'agr-ui';
      agr.type = 'text/javascript';
      agr.async = true;
      agr.src = config.agreementUISrc;

      document.body.appendChild(agr);
    }
  }

  renderZDChat = () => {
    const { userData } = store.SessionStore;
    const zdScript = document.querySelector('#ze-snippet');

    if(!zdScript) {
      let zdc = document.createElement('script');
      zdc.id = 'ze-snippet';
      zdc.type = 'text/javascript';
      zdc.async = true;
      zdc.src = 'https://static.zdassets.com/ekr/snippet.js?key=a3206868-bdac-4af5-a921-ee51087a581e';

      zdc.onload = function() {
        window.zE(function(){
          window.zE.identify({
            organization: userData.installSid
          });

          window.zE('webWidget', 'updateSettings', {
            webWidget: {
              offset: {
                vertical: '44px'
              }
            }
          });
        });
      }

      document.body.appendChild(zdc);
    }

    return null;
  }

  render() {
    // Import styles
    if(!document.querySelector('link[href*="screen.css"]')) {
      const { highContrast } = store.SessionStore;

      let defaultStyles = document.createElement('link');
      defaultStyles.rel = `${highContrast ? 'alternate stylesheet' : 'stylesheet '}`;
      defaultStyles.type = 'text/css';
      defaultStyles.href = './static/css/screen.css';

      let highContrastStyles = document.createElement('link');
      highContrastStyles.rel = `${highContrast ? 'stylesheet' : 'alternate stylesheet'}`;
      highContrastStyles.type = 'text/css';
      highContrastStyles.href = './static/css/hi-c.css';

      document.head.appendChild(defaultStyles);
      document.head.appendChild(highContrastStyles);
    }

    // Detect touch device
    const docRoot = document.querySelector('html');
    if ('ontouchstart' in document.documentElement) {
      docRoot.classList.add('touch');
    }

    // LaunchDarkly user config
    const ldConfig = {
      key: `External User ${Date.now()}`,
      custom: {
        installSid: sessionStorage.getItem('installSid') || '',
        courseSid: sessionStorage.getItem('courseSid') || '',
        userAgent: navigator.userAgent
      }
    }

    return (
      <LaunchDarkly clientId={config.ldApiKey} user={ldConfig}>
        <div className="viewport">
          <FeatureFlag
            flagKey="extension-chrome-store-id"
            renderFeatureCallback={this.handleChromeStoreId}
          />

          {React.cloneElement(this.props.children, this.props)}

          {(store.SessionStore.loading || store.SessionStore.loadingClass) &&
            <Loader store={store} />
          }

          {store.SessionStore.dialog &&
            <Dialog store={store} />
          }

          {store.SessionStore.confirm &&
            <Confirm store={store} />
          }

          {store.SessionStore.prompt &&
            <Prompt store={store} />
          }

          {store.SessionStore.toaster &&
            <Toaster store={store} />
          }

          {store.SessionStore.notification &&
            <Notification store={store} {...this.props} />
          }
        </div>
      </LaunchDarkly>
    )
  }
}

export default observer(AppOutside);


// WEBPACK FOOTER //
// ./src/app/components/AppOutsideOnboard.js